export default __webpack_public_path__ + "static/media/Banner-Estimulos.42e25b38.png";